import React from 'react';
import { useLocation } from 'react-router-dom';
import { usePostHog } from 'posthog-js/react';
import { NavigationItem } from './MainSidebar';
import { MenuButton } from './MenuButton';

type NavigationMainButtonProps = {
  setIsSidebarOpen: (isSidebarOpen: boolean) => void;
  navigationItem: NavigationItem;
  isSubMenuItem?: boolean;
};
export const NavigationItemButton = ({
  navigationItem,
  setIsSidebarOpen,
  isSubMenuItem,
}: NavigationMainButtonProps) => {
  const { key, name, icon, target, external, navigate, count } = navigationItem;
  const location = useLocation();
  const posthog = usePostHog();
  const itemIsActive = location.pathname === navigate;

  const handleClick = () => {
    posthog.capture('Sidebar menu pressed', { key });
    setIsSidebarOpen(false);
  };

  return (
    <MenuButton
      name={name}
      icon={icon}
      isSubMenuItem={isSubMenuItem}
      onClick={handleClick}
      itemIsActive={itemIsActive}
      navigate={navigate}
      external={external}
      target={target}
      count={count}
    />
  );
};
